import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const styles = makeStyles({
  checkbox: {},
});

export const CheckboxContainer = styled('div')`
  display: flex;
  justify-content: left;
  align-items: center;
`;
